import script from "./BpmnInstancePage.vue?vue&type=script&setup=true&lang=js"
export * from "./BpmnInstancePage.vue?vue&type=script&setup=true&lang=js"

import "./BpmnInstancePage.vue?vue&type=style&index=0&id=05d02bdd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d02bdd"]])

export default __exports__